export default "__VITE_ASSET__B7Iqx8jD__"